// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-table-dropdown .p-button-label {
  font-weight: unset;
}

.data-table-dropdown .custom-btn .p-button.p-button-outlined {
  width: 100%;
  color: #6c757d;
  padding-left: 0.75rem;
  text-align: left;
  border-color: #6c757d4d;
}

.custom-btn {
  width: 100%;
}

.custom-btn,
.data-table-dropdown .p-button-label {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.treeDropdownCheckbox:not(.treeDropdownCheckbox--without-hr, .dropdown-tree-hr_fisrtItem)
  .p-tree-container
  > .p-treenode:nth-child(2) {
  border-bottom: 1px solid rgb(201, 201, 201);
}

.mobile-department-overlay
  .p-tree-container
  > .p-treenode:nth-child(2) {
  border-bottom: 1px solid rgb(201, 201, 201) !important;
}

.treeDropdownCheckbox.dropdown-tree-hr_fisrtItem:not(.treeDropdownCheckbox--without-hr)
  .p-tree-container
  > .p-treenode:nth-child(1) {
  border-bottom: 1px solid rgb(201, 201, 201);
}

.hover-clear-button:hover {
  background-color: rgba(
    239,
    68,
    68,
    0.05
  ) !important; /* #EF4444 with 10% opacity */
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/DataTableDropdown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;;EAGE,sDAAsD;AACxD;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;EACE;;;;;cAKY,EAAE,6BAA6B;EAC3C,eAAe;AACjB","sourcesContent":[".data-table-dropdown .p-button-label {\n  font-weight: unset;\n}\n\n.data-table-dropdown .custom-btn .p-button.p-button-outlined {\n  width: 100%;\n  color: #6c757d;\n  padding-left: 0.75rem;\n  text-align: left;\n  border-color: #6c757d4d;\n}\n\n.custom-btn {\n  width: 100%;\n}\n\n.custom-btn,\n.data-table-dropdown .p-button-label {\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n.treeDropdownCheckbox:not(.treeDropdownCheckbox--without-hr, .dropdown-tree-hr_fisrtItem)\n  .p-tree-container\n  > .p-treenode:nth-child(2) {\n  border-bottom: 1px solid rgb(201, 201, 201);\n}\n\n.mobile-department-overlay\n  .p-tree-container\n  > .p-treenode:nth-child(2) {\n  border-bottom: 1px solid rgb(201, 201, 201) !important;\n}\n\n.treeDropdownCheckbox.dropdown-tree-hr_fisrtItem:not(.treeDropdownCheckbox--without-hr)\n  .p-tree-container\n  > .p-treenode:nth-child(1) {\n  border-bottom: 1px solid rgb(201, 201, 201);\n}\n\n.hover-clear-button:hover {\n  background-color: rgba(\n    239,\n    68,\n    68,\n    0.05\n  ) !important; /* #EF4444 with 10% opacity */\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
